import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, } from '@angular/forms'; 
import { Subject } from 'rxjs/internal/Subject';
import { ConfirmPasswordValidator } from './confirm-password.validator'; 
import { faEye, faEyeSlash, IconDefinition } from '@fortawesome/free-regular-svg-icons';
import { CommonService } from '../../../common/services/common.service';
import { ProfileStoreService } from '../../create-profile/store/profile.store';
import { ProfileRequest, ProfileUpdateResponse, Settings } from '../../create-profile/interface/profile.i';
import { CreateProfileService } from '../../../core/routing/services/profile/create-profile.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { Utils } from '../../../common/utils/utils';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';

@Component({
  selector: 'iposcen-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  @ViewChild('profileChangePasswordModal') modalContent: TemplateRef<ChangePasswordComponent>;
  @Output() readonly isMasterPwdChangged = new EventEmitter();
  @Output() readonly isUnInstallPwdChanged = new EventEmitter();
  private modalRef: NgbModalRef;
  private modalOption : NgbModalOptions = {};
  changePasswordForm: FormGroup= new FormGroup({});;
  submitted: boolean = false;
  form: FormGroup = new FormGroup({});
  showHideEyeIcon: boolean;
  showHideEyeIcon2: boolean;
  displayEye: IconDefinition;
  type: string; //For Master/ uninstall pwd ref
  settings:  Settings; 
  profileDataSet: ProfileRequest;
  profileID: string;
  enterPrimaryPassPlaceholderText: string;
  confirmPrimaryPassText: string;
  private ngUnsubscribe = new Subject<boolean>();

  constructor(
    private modalService: NgbModal, 
    private fb: FormBuilder,
    private cmnService: CommonService,
    private profileStoreService: ProfileStoreService,
    private createProfileService: CreateProfileService,
    private googleAnalyticsService: GoogleAnalyticsService
  ) { 

    this.buildForm(fb);
  }
  ngOnInit(): void {
    this.profileDataSet = this.profileStoreService.currentWorkingProfile;
    this.profileID = this.createProfileService.getProfileId();
    if (this.profileDataSet && this.profileDataSet?.profileId && this.profileDataSet?.settings) {
      this.settings = JSON.parse(this.profileDataSet.settings);
    }
  }

  buildForm(fb){
    this.form = fb.group({
      password: ['', [Validators.required,Validators.minLength(5)]],
      confirm_password: ['', [Validators.required, Validators.minLength(5)]]
    }, { 
      validator: ConfirmPasswordValidator('password', 'confirm_password')
    })
  }

  //To toggle between type text and passowrd
  toggleshowHideEyeIcon(key: string) {
    this[key] = !this[key];
  }
  
  //Function to get formControls. instead of this.form.controls just formCont. can be used.
  get formCont(){
    return this.form.controls;
  }
  
  //Function to send password data to API
  submit(type: String){
    if(type === GlobalConstants.PRIMARY){ // Master Text changed to Primary. But will not be changing in data structure.
      this.settings.masterPwd = this.formCont.password.value;
      // For UAT-464, emitting the flag for the passwords entered by user.
      this.isMasterPwdChangged.emit(true);
      this.googleAnalyticsService.pushPasswordChanges(GlobalConstants.PRIMARY_PASSWORD_CHANGES_PUSHED); // IIT2-5312
    }else{
      this.settings.uninstallPwd = this.formCont.password.value;
      // For UAT-464, emitting the flag for the passwords entered by user.
      this.isUnInstallPwdChanged.emit(true);
      this.googleAnalyticsService.pushPasswordChanges(GlobalConstants.UNINSTALL_PASSWORD_CHANGES_PUSHED); // IIT2-5312
    }
    this.createProfileService.updateProfile(this.profileID, { settings: JSON.stringify(this.settings) })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        const updateProfileStoreLogo = data.profile as ProfileUpdateResponse;
        this.profileStoreService.updateProfileData(updateProfileStoreLogo);
        this.modalRef.close();
        this.cmnService.emitPasswordChangeSuccess();
    },
    error => {
      Utils.handleError(error, this.constructor.name);
    });   
  }

  //To open modal
  open(data) {
    this.buildForm(this.fb);
    this.type = data;
    this.enterPrimaryPassPlaceholderText = $localize`:@@change-password.primary-pass-placeholder.text:Enter ${this.type} Password`;
    this.confirmPrimaryPassText = $localize`:@@change-password.confirm-pass.text:Confirm ${this.type} Password`;
    this.modalOption.backdrop = GlobalConstants.STATIC;
    this.modalOption.keyboard = false;
    this.modalRef = this.modalService.open(this.modalContent, this.modalOption);
    this.modalRef.result.then();
  }

  close() {
    this.modalRef.close();
  }

  dismiss() {
    this.modalRef.dismiss();
  }
}
